import React, { useContext } from 'react';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../../CabsLandingContext';
import {
  OUTSTATION_ONE_WAY,
  OUTSTATION_ROUND_TRIP,
  isOutstationCheck
} from '../../../constants/tripTypes';
import { CityLocation } from '../../runtime-typechecker';
import { SET_STOPOVERS } from '../cabsLandingPageState';
import {
  MOB_CABS_LANDING_OW_ADD_STOPS_CLICK,
  MOB_CABS_LANDING_RT_ADD_STOPS_CLICK
} from '../../../constants/omnitureConstants';

export const StopOverAdd = () => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const dispatch = useContext(CabsLandingDispatchContext);

  const { travelFor, stopOvers, trackTemplateEvent } = cabsLandingContext;

  const setStopOvers = stopOvers => {
    dispatch && dispatch({ type: SET_STOPOVERS, newStateValue: stopOvers });
  };

  const onStopOverAdd = () => {
    if (travelFor === OUTSTATION_ONE_WAY)
      trackTemplateEvent(MOB_CABS_LANDING_OW_ADD_STOPS_CLICK);
    else trackTemplateEvent(MOB_CABS_LANDING_RT_ADD_STOPS_CLICK);
    const newStopOvers = stopOvers.map(cityLocation => cityLocation);
    const cityLocation: CityLocation = {
      city: '',
      subText: '',
      placeId: '',
      geoLocation: undefined,
      cityCode: ''
    };
    newStopOvers.push(cityLocation);
    setStopOvers(newStopOvers);
  };

  return (
    <>
      {isOutstationCheck(travelFor) ? (
        <>
          {
            <div onClick={onStopOverAdd} className="addMoreStops">
              {stopOvers && stopOvers.length == 0 ? (
                <div className="deepskyBlueText latoBlack paddingT10 font13">
                  + Add Stops
                </div>
              ) : null}
              {stopOvers && stopOvers.length > 0 && stopOvers.length < 5 ? (
                <div className="deepskyBlueText latoBlack paddingT10 font13">
                  + Add More Stops
                </div>
              ) : null}
            </div>
          }
        </>
      ) : (
        <div className="addMoreStops"></div>
      )}
    </>
  );
};
